import React from 'react';

import { IconSpill } from 'components/icons/spill';

export const Icon = () => <IconSpill width="172" height="192" />;
